import Lightning from "@lightningjs/sdk/src/Lightning";
import NoficationBox from "./notification-box";
import MessagageBox from "./message-box";
import Router from "@lightningjs/sdk/src/Router";
import { AppData } from "@lightningjs/sdk";
import { AppSetup } from "../../lib/app-setup";

export interface NotificationWidgetTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class NotificationWidget
  extends Lightning.Component<NotificationWidgetTemplateSpec>
  implements Lightning.Component<NotificationWidgetTemplateSpec>
{

  static override _template(): Lightning.Component.Template<NotificationWidgetTemplateSpec> {
    return {
      w: 1920,
      h: 1080,
      flex: { direction:'column',alignItems: 'flex-start', justifyContent: 'flex-end' },
      children: []
    }
  }

  override _onActivated() {
    //this.showNotification('Successfully added to Queue List !')
  }

  override _init() {
    //
  }

  override _getFocused() {
    const lastChild = this.children.length - 1
    return this.children[lastChild]
  }

  showNotification(msg: string) {
    this.patch({
        flex: { direction:'column',alignItems: 'flex-start', justifyContent: 'flex-end' },
    })
    this.childList.add({
        type: NoficationBox,
        msg: msg,
      })
    this._refocus()
  }

  showMessage(msg: string) {
    this.children = [] //cleared the previous notifications box - IPTV-
    this.patch({
        flex: { direction:'column',alignItems: 'center', justifyContent: 'center' },
    })
    this.childList.add({
        type: MessagageBox,
        msg: msg,
      })
      Router.focusWidget('notification')
  }

  $closeMessageBox() {
    Router.focusPage()
    this.children = []
    const { platform } = AppData as AppSetup;
    platform?.textToSpeach('Close Message Box')
  }
}
